import React from "react";
import ReactDOM from "react-dom/client";
import EAOneApp from "./EAOneApp";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <EAOneApp />
    </BrowserRouter>
  </React.StrictMode>
);
